import { Card } from "@mantine/core";
import clsx from "clsx";
import "./Card.css";

const CustomCard = ({ children, className, ...props }: any) => (
  <Card withBorder className={clsx("custom-card", className)} {...props}>
    {children}
  </Card>
);

export default CustomCard;
